import React, { useEffect, useState } from "react";
import {
  Container, Row, Col, Card, Button, Nav, Form, Image, Badge,
} from "react-bootstrap";
import { BsDot } from "react-icons/bs";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import avatar from "../../assets/images/users/avatar-1.jpg";
import { userData } from "./model/profile.model";
import { IoSettingsOutline } from "react-icons/io5";
import '../Authentication/IN.css'

const UserProfile: React.FC = () => {
  const [activeTab, setActiveTab] = useState("account");
  const [profileData, setProfileData] = useState<userData>();
  const authUser = localStorage.getItem("authUser");
  const initial = profileData?.name ? profileData.name.charAt(0).toUpperCase() : "?";


  const selectUser = createSelector(
    (state: any) => state.Profile,
    (user) => user?.user
  );

  const user = useSelector(selectUser);

  useEffect(() => {
    if (authUser) {
      const obj = JSON.parse(authUser);
      setProfileData(obj);
    }
  }, [user]);

  return (
   <Container fluid className="page-content px-4 bg-light">
      <Row className="gx-3">
        {/* Sidebar */}
        <Col
       md={2}
      className="sidebar d-flex flex-column border-end bg-white shadow-sm p-3"
        >
          <div className="text-end">
            <BsDot size={48} className="text-success" />
          </div>
          <div className="text-center mb-3">
            <div className="avatar-circle mx-auto">
              {initial}
            </div>
            <h6 className="mt-3 mb-0 fw-bold">{profileData?.name}</h6>
            <small className="text-muted d-block">Role:</small>
            <Badge bg="secondary" className="mt-1">
              {profileData?.roleName}
            </Badge>
          </div>
          <Nav defaultActiveKey="profile" className="flex-column">
            {/* Example Nav Link */}
            {/* <Nav.Link
          onClick={() => setActiveTab("account")}
          className={`mb-2 ${activeTab === "account" ? "fw-bold text-primary" : ""}`}
        >
          <IoSettingsOutline size={18} className="me-2" /> Account Settings
        </Nav.Link> */}
          </Nav>
        </Col>

        {/* Main Content */}
        <Col md={10}
      className="sidebar d-flex flex-column border-end bg-white shadow-sm p-3"
        
        >
          <Card className="p-4 shadow-sm content-fixed-height page-content">
            <Row className="align-items-center mb-3">
              <Col xs="auto">
                <div className="avatar-circle">
                  {initial}
                </div>
              </Col>
              <Col>
                <h5 className="mb-0 fw-semibold">{profileData?.name}</h5>
                <small className="text-muted">{profileData?.emailAddress}</small>
              </Col>
            </Row>

            <Nav variant="tabs" className="mt-3" activeKey={activeTab}>
              <Nav.Item>
                <Nav.Link eventKey="account" onClick={() => setActiveTab('account')}>
                  Account
                </Nav.Link>
              </Nav.Item>
            </Nav>

            {activeTab === 'account' && (
              <div className="pt-4 px-3 border-top">
                <h5 className="fw-bold mb-4">Personal Details</h5>
                <Row className="mb-3">
                  <Col md={6}>
                    <strong>Name:</strong>{' '}
                    <span className="text-muted">{profileData?.name}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Email:</strong>{' '}
                    <span className="text-muted">{profileData?.emailAddress}</span>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <strong>Mobile:</strong>{' '}
                    <span className="text-muted">{profileData?.mobileNumber}</span>
                  </Col>
                  <Col md={6}>
                    <strong>Username:</strong>{' '}
                    <span className="text-muted">{profileData?.userName}</span>
                  </Col>
                </Row>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Container>



  );
};

export default UserProfile;
